module.exports = __webpack_public_path__ + "static/img/ion_ci_01.ddbe6164.png";